/** Valores técnicos persistidos en AuditoriaCambioEntidad (AuditEntityRegistry + auditorías manuales). */
export const AUDITORIA_ENTIDADES = [
  { value: 'Alumno', label: 'Alumno' },
  { value: 'AlumnoxCarrera', label: 'Alumno por Carrera' },
  { value: 'AnioAcademico', label: 'Año Académico' },
  { value: 'ActaCursadum', label: 'Acta de Cursada' },
  { value: 'ActaExaman', label: 'Acta de Examen' },
  { value: 'Carrera', label: 'Carrera' },
  { value: 'CorrelatividadesCursar', label: 'Correlatividad para Cursar' },
  { value: 'CorrelatividadesRendir', label: 'Correlatividad para Rendir' },
  { value: 'Cursada', label: 'Cursada' },
  { value: 'DetalleActaCursadum', label: 'Detalle de Acta de Cursada' },
  { value: 'DetalleActum', label: 'Detalle de Acta de Examen' },
  { value: 'EstadoCurricular', label: 'Estado Curricular' },
  { value: 'HistoriaAcademicaCursadum', label: 'Historia Académica de Cursada' },
  { value: 'HistoriaAcademicaExaman', label: 'Historia Académica de Examen' },
  { value: 'InscripcionCursadum', label: 'Inscripción a Cursada' },
  { value: 'InscripcionExaman', label: 'Inscripción a Examen' },
  { value: 'MateriasCarrera', label: 'Materia por Carrera' },
  { value: 'MesaExaman', label: 'Mesa de Examen' },
  { value: 'PeriodoCursadum', label: 'Período de Cursada' },
  { value: 'PeriodoExaman', label: 'Período de Examen' },
  { value: 'Usuario', label: 'Usuario' },
];

const ENTIDAD_LABELS = AUDITORIA_ENTIDADES.reduce((map, item) => {
  map[item.value] = item.label;
  return map;
}, {});

export const AUDITORIA_ENTIDAD_FILTER_OPTIONS = [...AUDITORIA_ENTIDADES].sort((a, b) =>
  a.label.localeCompare(b.label, 'es')
);

export function getEntidadLabel(rawEntidad) {
  const value = (rawEntidad || '').trim();
  if (!value) {
    return '—';
  }
  return ENTIDAD_LABELS[value] || value;
}
